module.exports = __webpack_public_path__ + "img/parking-m-3.3b72af4d.jpg";